import storageKeys from "config/storageKeys";
import { Theme } from "models";
import { atom } from "recoil";
import localStorageEffect from "recoil/Effects/localStorageEffect";

const AtomTheme = atom<Theme>({
  key: "AtomTheme",
  default: "light",
  effects_UNSTABLE: [localStorageEffect(storageKeys.theme)],
});
export default AtomTheme;
